@if (group.count) {
    <div class="flex flex-col mb-5" [ngClass]="{ 'hidden' : !isVisible }">
        <div class="flex flex-row gap-2">
            <div class="align-middle items-center justify-center flex">
                <div class="w-4 h-4">
                    <svg>
                        <image [attr.xlink:href]="group.iconSvg" class="w-4 h-4" />
                    </svg>
                </div>
            </div>
            <div class="font-bold">
                {{ group.name }}
            </div>
            <div>
                ({{ group.count }})
            </div>
        </div>
        <div class="flex flex-col items-center">
            @for (deckCardRow of deckCardRows ; track deckCardRow.name) {
                <magic-deck-multi-row 
                    [isOwnDeck]="isOwnDeck"
                    [deck]="deck"
                    [deckComponent]="deckComponent"
                    [deckLayerComponent]="deckLayerComponent"
                    [deckGroupComponent]="this"
                    [deckCards]="deckCardRow.cards" 
                    class="table-row text-sm group"></magic-deck-multi-row>
            }
        </div>
    </div>
}
